import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function useLoad(url) {
  const [data, setData] = useState(null);
  const [state, setState] = useState({ loaded: false, error: null });
  const reload = useCallback(async () => {
    if (!url) return;
    setState((s) => ({ ...s, error: null }));
    try {
      const { data } = await api.get(url);
      setData(data);
      setState({ loaded: true, error: null });
    } catch (e) {
      setState({ loaded: true, error: errMsg(e) });
      toast.error(errMsg(e));
    }
  }, [url]);
  useEffect(() => { reload(); }, [reload]);
  return [data, reload, state];
}

export async function act(fn, success) {
  try {
    const r = await fn();
    if (success) toast.success(success);
    return r?.data ?? true;
  } catch (e) {
    toast.error(errMsg(e));
    return null;
  }
}
